// ========================================
// ポップアップバナー（汎用）
// ========================================
function setupBanner(bannerId, closeButtonSelector, localStorageKey) {
  const banner = document.getElementById(bannerId);
  const closeButton = document.querySelector(closeButtonSelector);
  const transitionDuration = 300;
  const fadeInDelay = 10;

  let hideTimeoutId = null;

  if (!banner) {
    console.warn(`Banner element with ID '${bannerId}' not found.`);
    return;
  }

  if (localStorage.getItem(localStorageKey) === "true") {
    banner.classList.add("hidden");
  } else {
    banner.classList.add("hidden");
  }

  if (closeButton) {
    closeButton.addEventListener("click", function () {
      if (hideTimeoutId) {
        clearTimeout(hideTimeoutId);
        hideTimeoutId = null;
      }

      banner.classList.remove("is-visible");

      hideTimeoutId = setTimeout(() => {
        banner.classList.add("hidden");
        hideTimeoutId = null;
      }, transitionDuration);

      localStorage.setItem(localStorageKey, "true");
    });
  }

  window.addEventListener("scroll", function () {
    if (localStorage.getItem(localStorageKey) === "true") {
      return;
    }

    const scrollY = window.scrollY;
    const documentHeight = document.documentElement.scrollHeight;
    const windowHeight = window.innerHeight;
    const distanceFromBottom = documentHeight - (scrollY + windowHeight);

    // 表示条件: 100pxスクロール済み かつ フッターから600px以上離れている
    const shouldShow = scrollY > 100 && distanceFromBottom >= 600;

    if (shouldShow) {
      if (hideTimeoutId) {
        clearTimeout(hideTimeoutId);
        hideTimeoutId = null;
      }

      if (banner.classList.contains("hidden")) {
        banner.classList.remove("hidden");
        setTimeout(() => {
          banner.classList.add("is-visible");
        }, fadeInDelay);
      } else if (!banner.classList.contains("is-visible")) {
        banner.classList.add("is-visible");
      }
    } else {
      if (banner.classList.contains("is-visible")) {
        if (hideTimeoutId) {
          clearTimeout(hideTimeoutId);
          hideTimeoutId = null;
        }

        banner.classList.remove("is-visible");

        hideTimeoutId = setTimeout(() => {
          banner.classList.add("hidden");
          hideTimeoutId = null;
        }, transitionDuration);
      }
    }
  });
}

// ========================================
// DOMContentLoaded
// ========================================
document.addEventListener("DOMContentLoaded", function () {
  // ========================================
  // PC メガメニュー（ブランド）ホバー制御
  // ========================================
  const megaMenu = document.getElementById("megaMenu");
  const brandTrigger = document.querySelector(".l-header__dropdown-inner");

  if (megaMenu && brandTrigger) {
    let megaTimer = null;

    const openMega = () => {
      clearTimeout(megaTimer);
      megaMenu.classList.add("is-open");
    };

    const closeMega = () => {
      megaTimer = setTimeout(() => {
        megaMenu.classList.remove("is-open");
      }, 120);
    };

    brandTrigger.addEventListener("mouseenter", openMega);
    brandTrigger.addEventListener("mouseleave", closeMega);
    megaMenu.addEventListener("mouseenter", openMega);
    megaMenu.addEventListener("mouseleave", closeMega);
  }

  // ========================================
  // 記事シェアボタン
  // ========================================
  // URLコピー
  const copyUrlBtn = document.getElementById("copyUrlBtn");
  if (copyUrlBtn) {
    copyUrlBtn.addEventListener("click", function () {
      const url = location.href;
      navigator.clipboard.writeText(url).then(function () {
        const msg = document.getElementById("copyMsg");
        if (msg) {
          msg.textContent = "リンクをコピーしました";
          setTimeout(function () {
            msg.textContent = "";
          }, 2500);
        }
      });
    });
  }

  // X（Twitter）シェア
  const shareX = document.getElementById("shareX");
  if (shareX) {
    shareX.href =
      "https://twitter.com/intent/tweet?url=" +
      encodeURIComponent(location.href) +
      "&text=" +
      encodeURIComponent(document.title);
  }

  // Facebook シェア
  const shareFacebook = document.getElementById("shareFacebook");
  if (shareFacebook) {
    shareFacebook.href =
      "https://www.facebook.com/sharer/sharer.php?u=" +
      encodeURIComponent(location.href);
  }

  // ---------- バナーセットアップ ----------
  setupBanner("myBanner", "#myBanner .close-banner-1", "hasBannerBeenClosed1");
  setupBanner(
    "myBanner2",
    "#myBanner2 .close-banner-2",
    "hasBannerBeenClosed2"
  );

  // ========================================
  // SP ドロワーメニュー 開閉
  // ========================================
  const menuToggle = document.getElementById("menuToggle");
  const drawerMenu = document.getElementById("drawerMenu");
  const drawerOverlay = document.getElementById("drawerOverlay");

  function openDrawer() {
    drawerMenu.classList.add("is-open");
    drawerOverlay.classList.add("is-open");
    menuToggle.classList.add("is-open");
    menuToggle.setAttribute("aria-expanded", "true");
    drawerMenu.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }

  function closeDrawer() {
    drawerMenu.classList.remove("is-open");
    drawerOverlay.classList.remove("is-open");
    menuToggle.classList.remove("is-open");
    menuToggle.setAttribute("aria-expanded", "false");
    drawerMenu.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  if (menuToggle) {
    menuToggle.addEventListener("click", function () {
      const isOpen = drawerMenu.classList.contains("is-open");
      isOpen ? closeDrawer() : openDrawer();
    });
  }

  if (drawerOverlay) {
    drawerOverlay.addEventListener("click", closeDrawer);
  }

  // ESCキーで閉じる
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeDrawer();
  });

  // ========================================
  // キャンペーンバッジ 閉じる
  // ========================================
  const campBadgeClose = document.getElementById("campBadgeClose");
  if (campBadgeClose) {
    campBadgeClose.addEventListener("click", function () {
      const badge = document.getElementById("campBadge");
      if (badge) badge.closest(".top-brand__badge-wrap").style.display = "none";
    });
  }

  // ---------- マッチハイト ----------
  if (typeof $ !== "undefined" && typeof $.fn.matchHeight !== "undefined") {
    $(".p-product-list li h3").matchHeight();
    $(".p-product-list li .capacity").matchHeight();
    $(".p-product-list li .price").matchHeight();
  }

  // ---------- aboutスライダー ----------
  if (document.querySelector(".about-slider")) {
    new Swiper(".about-slider", {
      loop: true,
      slidesPerView: "auto",
      spaceBetween: 20,
      speed: 4000,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      pauseOnMouseEnter: true,
    });
  }

  // ---------- トップ FVスライダー ----------
  const fvSliderEl = document.querySelector(".top-fv-slider");
  if (fvSliderEl) {
    new Swiper(fvSliderEl, {
      loop: true,
      speed: 800,
      centeredSlides: true,
      spaceBetween: 10,
      slidesPerView: "auto",
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      breakpoints: {
        769: {
          slidesPerView: "auto",
          spaceBetween: 20,
        },
      },
    });
  }
  // ---------- 商品タブ切り替え ----------
  document.querySelectorAll(".c-brand-section__tab").forEach(function (tab) {
    tab.addEventListener("click", function () {
      const tabId = this.dataset.tab;

      // 同じタブグループ内のアクティブを切り替え
      const allTabs = this.parentElement.querySelectorAll(
        ".c-brand-section__tab"
      );
      allTabs.forEach(function (t) {
        t.classList.remove("is-active");
      });
      this.classList.add("is-active");

      // 同セクション内のコンテンツを切り替え
      const section = this.closest(".c-brand-section, .c-amehare-section");
      if (section) {
        section.querySelectorAll(".c-tab-content").forEach(function (c) {
          c.classList.remove("is-active");
        });
        const target = section.querySelector("#" + tabId);
        if (target) target.classList.add("is-active");
      }
    });
  });

  // ---------- スクロールフェードイン ----------
  const fadeEls = document.querySelectorAll(".fade-up");
  if (fadeEls.length > 0) {
    const fadeObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            fadeObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.05, rootMargin: "0px 0px -40px 0px" }
    );
    fadeEls.forEach(function (el) {
      fadeObserver.observe(el);
    });
    // ページ読み込み時にすでに画面内にある要素は即時表示
    setTimeout(function () {
      fadeEls.forEach(function (el) {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight) {
          el.classList.add("is-visible");
        }
      });
    }, 100);
  }

  // ---------- レシピページ スティッキーメニュー ----------
  const sections = document.querySelectorAll(".p-recipe-main-sec");
  const menuLinks = document.querySelectorAll(".p-recipe-menu-sticy li a");

  if (sections.length > 0 && menuLinks.length > 0) {
    const recipeObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const id = entry.target.id;
            menuLinks.forEach((link) => {
              link.classList.remove("active");
              if (link.getAttribute("href") === `#${id}`) {
                link.classList.add("active");
              }
            });
          }
        });
      },
      {
        rootMargin: "-40% 0px -55% 0px",
        threshold: 0,
      }
    );
    sections.forEach((section) => recipeObserver.observe(section));
  }
});

// ========================================
// 商品詳細スライダー（DOMContentLoaded内に統合）
// ========================================
document.addEventListener("DOMContentLoaded", function () {
  const thumbnailEl = document.querySelector(
    ".p-product-slider .slider-thumbnail"
  );
  const sliderEl = document.querySelector(".p-product-slider .slider");

  if (!thumbnailEl || !sliderEl) return;

  const sliderThumbnail = new Swiper(thumbnailEl, {
    slidesPerView: "auto",
    spaceBetween: 8,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    loop: true,
    freeMode: false,
  });

  new Swiper(sliderEl, {
    loop: true,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    thumbs: {
      swiper: sliderThumbnail,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    on: {
      slideChange: function () {
        sliderThumbnail.slideTo(this.realIndex);
      },
    },
  });
});
// ========================================
// あめはれ商品詳細スライダー
// ========================================
// スライダーのインスタンスを保持する変数
let swiperAmehare = undefined;

function initSwiper() {
  const windowWidth = window.innerWidth;
  const breakpoint = 769; // 769px以上でPC表示

  // 対象の要素を取得
  const productInfo = document.querySelector(".p-product-info");
  const amehareImage = document.querySelector(".p-product-amehare-image");

  // 769px以上（PC）の場合
  if (windowWidth >= breakpoint) {
    // 1. Swiperが初期化されている場合は破棄する
    if (swiperAmehare !== undefined) {
      swiperAmehare.destroy(true, true);
      swiperAmehare = undefined;
    }

    // 2. 高さを揃える処理（要素が存在する場合のみ実行）
    if (productInfo && amehareImage) {
      // .p-product-info の現在の高さを取得（余白などを含めた高さ）
      const infoHeight = productInfo.offsetHeight;
      // .p-product-amehare-image に同じ高さを設定
      amehareImage.style.height = infoHeight + "px";
    }
  }
  // 769px未満（スマホ・タブレット）の場合
  else {
    // 1. PC用の高さ設定を解除（スマホでは中身に応じた自動高さに戻す）
    if (amehareImage) {
      amehareImage.style.height = "auto";
    }

    // 2. まだSwiperが初期化されていない場合のみ初期化
    if (swiperAmehare === undefined) {
      swiperAmehare = new Swiper(".swiper-amehare-product", {
        loop: true,
        slidesPerView: 1.2,
        spaceBetween: 10,
      });
    }
  }
}

// ページ読み込み時、リサイズ時に実行
window.addEventListener("load", initSwiper);
window.addEventListener("resize", initSwiper);
